<template>
  <div id="todo-app">
    <vs-sidebar
      class="sidebarx"
      parent="#todo-app"
      default-index="1"
      color="primary"
      spacer
      v-model="isSidebarActiveLocal"
    >
      <div class="header-sidebar" slot="header">
        <b-row style="width: 100%">
          <b-col>
            <b-form-input
              v-model="searchedValue"
              id="searchedValue"
              @keyup.enter="filterStockList"
              ref="searchedValueRef"
              style="margin-bottom: 8px"
            />
          </b-col>
          <b-col cols="1">
            <b-button
              v-on:click="filterStockList"
              size="sm"
              variant="outline-light"
              id="button-with-loading"
              class="w-full vs-con-loading__container"
            >
              <Icon
                icon="wpf:search"
                width="25"
                height="25"
                color="black"
                v-b-tooltip.hover.bottom="$t('ARA')"
              />
            </b-button>
          </b-col>
        </b-row>
      </div>
      <component
        :is="scrollbarTag"
        ref="scroll"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <b-row align-v="stretch" style="margin: 15px">
          <b-col
            v-for="(value, columnIndex) in stockList"
            :key="columnIndex"
            cols="3"
            style="
              border: black 0.1px solid;
              height: 100%;
              padding-right: 3px !important;
              padding-left: 3px !important;
              text-align: center;
            "
          >
            <div>
              <b-row>
                <b-col cols="12">
                  <h6
                    style="
                      text-align: end;
                      font-weight: bold;
                      color: rgb(3, 14, 215) !important;
                    "
                    class="mr-3"
                  >
                    {{ value.stockCode }}
                  </h6>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <vs-button color="primary" type="flat">
                    <img
                      loading="lazy"
                      decoding="async"
                      v-on:click="showImageDetails(value)"
                      style="
                        height: auto;
                        object-fit: cover;
                        object-position: center;
                        width: 100px;
                      "
                      :src="value.url_image"
                      class="attachment-portfolio_thumbnail size-portfolio_thumbnail wp-post-image"
                      alt=""
                    />
                  </vs-button>
                  <div style="position: relative" class="ml-3 mr-3">
                    <b-row>
                      <b-col>
                        <h6
                          style="color: red !important; font-size: x-small"
                          v-if="value.stockCount.toString().includes('-')"
                        >
                          {{ $t("onstream") }}
                        </h6>
                        <h6 style="color: red !important; font-size: x-small" v-else>
                          {{
                            value.stockCount !== undefined && value.stockCount !== ""
                              ? new Intl.NumberFormat().format(
                                  parseInt(value.stockCount)
                                ) +
                                " " +
                                $t("piece")
                              : $t("onstream")
                          }}
                        </h6>
                      </b-col>

                      <b-col>
                        <h6
                          style="
                            font-size: x-small;
                            color: red !important;
                            text-align: end;
                          "
                          v-if="currency == 'TL'"
                        >
                          {{
                            new Intl.NumberFormat("tr-TR", {
                              style: "currency",
                              currency: "TRY",
                            }).format(
                              parseFloat(value.stockPrice.toString().replace(",", "."))
                            )
                          }}
                        </h6>

                        <h6
                          style="
                            font-size: x-small;
                            color: red !important;
                            text-align: end;
                          "
                          v-else-if="currency == 'USD'"
                          v-b-tooltip.hover.bottom="value.stockCurrencyUsd"
                        >
                          {{
                            new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(
                              parseFloat(
                                value.stockCurrencyUsdPrice.toString().replace(",", ".")
                              )
                            )
                          }}
                        </h6>
                        <h6
                          style="
                            font-size: x-small;
                            color: red !important;
                            text-align: end;
                          "
                          v-else-if="currency == 'EUR'"
                          v-b-tooltip.hover.bottom="value.stockCurrencyEur"
                        >
                          {{
                            new Intl.NumberFormat("de-DE", {
                              style: "currency",
                              currency: "EUR",
                            }).format(
                              parseFloat(
                                value.stockCurrencyEurPrice.toString().replace(",", ".")
                              )
                            )
                          }}
                        </h6>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col align-h="end">
                        <span
                          style="font-size: 10px; color: black; margin: 0px"
                          v-if="value.attr1_cins"
                        >
                          {{ value.attr1_cins.replace("cm", "") }} /
                        </span>
                        <span
                          style="font-size: 10px; color: black; margin: 0px"
                          v-if="value.attr2_en"
                        >
                          {{ value.attr2_en.replace("cm", "") }} x {{ value.attr3_boy }}
                        </span>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </component>
    </vs-sidebar>
    <imageShow
      :popupResimSw="imagePopup"
      @closeSidebar="closeSidebar"
      :imgSrc="imgSrc"
      :stockCode="stockCode"
      :stockName="stockName"
      :selectedValue="selectedValue"
    />
  </div>
</template>
<script>
import imageShow from "./pages/components/imageShow.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { Icon } from "@iconify/vue2";
export default {
  components: {
    VuePerfectScrollbar,
    imageShow,
    Icon,
  },
  data() {
    return {
      imagePopup: false,
      imgSrc: "",
      stockCode: "",
      searchedValue: "",
      selectedValue: "",
      stockName: "",
      stockList: [],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },

  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    currency: "",
  },
  methods: {
    imageShowBtn() {
      this.imagePopup = true;
    },
    closeSidebar() {
      this.imagePopup = false;
    },

    showImageDetails(value) {
      this.$root.$emit("filterStockListF", value.stockCode);
      this.isSidebarActiveLocal = false;
      this.imgSrc = value.url_image;
      this.stockCode = value.stockCode;
      this.selectedValue = value;

      this.stockName = value.stockName;
      //    this.imageShowBtn();
    },
    filterStockList() { 
      try {
        this.$vs.loading({
          background: "#0064fa",
          color: "#fff",
          container: "#button-with-loading",
          scale: 0.45,
        });

        let args = {
          pageCounts: "120000",
          ilkKayit: 0,
          searched: this.searchedValue,
        };
        this.$store.dispatch("getDataStock", args).then((response) => { 
          this.stockList = response; 
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    currency(val) {
      return val;
    },
    isSidebarActive(val) {  

      if (val == true) {
        this.$nextTick(() => {
          this.$refs.searchedValueRef.focus();
        });
      
      } 
      return val;
    },
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
  },
};
</script>
<style lang="scss">
.vs-sidebar {
  max-width: 700px !important;
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 10px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
<style lang="stylus">

.header-sidebar
  display flex
  align-items center
  justify-content center
  flex-direction column
  width 100%
  h4
    display flex
    align-items center
    justify-content center
    width 100%
    > button
      margin-left 10px
.footer-sidebar
  display flex
  align-items center
  justify-content space-between
  width 100%
  > button
      border 0px solid rgba(0,0,0,0) !important
      border-left 1px solid rgba(0,0,0,.07) !important
      border-radius 0px !important
</style>
